import { Component, NgZone, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { NavService } from './services/nav.service';
import { NotifyService } from './services/notify.service';
import { UnauthorizeViewComponent } from './layout/unauthorize/unauthorizeview.component';
import { AuthorizeViewComponent } from './layout/authorize/authorizeview.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NotityType } from './model/notify.enun'
import { NgxSpinnerModule } from 'ngx-spinner';
import { IdleTimeoutService } from './services/idletimeout.service';
import { AlertComponent } from './shared/alert/alert.component';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [UnauthorizeViewComponent, AuthorizeViewComponent, NgbToastModule, CommonModule, NgxSpinnerModule, AlertComponent],
})
export class AppComponent {
  [x: string]: any;
  title = 'WILD WEB';
  IsAuthenticated: boolean = false;
  @ViewChild("alertContent", { static: true }) _alertModal!: AlertComponent;

  constructor(public auth: AuthService, public notify: NotifyService, public idleTimeoutService: IdleTimeoutService) {


  }
  ngOnInit(): void {
    this.idleTimeoutService.setAlert(this._alertModal);
   
  }
  // constructor(
  //   public auth: AuthService,
  //   private nav: NavService,
  //   public notify: NotifyService
  // ) {}
}
